import { AuthenticationServiceTokens as Tokens } from '../di-tokens';
import type { JWTAuthenticationService, VueRouterRedirectionService, JWTLoginSessionManager } from '../services';
import type { Credentials } from '../domain';

/**
 * User wants to sign in into the application.
 */
export class LoginUseCase {
    public static inject = [Tokens.AuthenticationService, Tokens.SessionManager, Tokens.RedirectService] as const;

    public constructor(
        private authService: JWTAuthenticationService,
        private sessionManager: JWTLoginSessionManager,
        private redirectService: VueRouterRedirectionService
    ) {}

    public async logIn(credentials: Credentials) {
        const authData = await this.authService.logIn(credentials.email, credentials.password);
        this.sessionManager.start(authData.data.token);

        if (this.redirectService.hasRedirectParamInQuery()) {
            await this.redirectService.redirectToPagePassedInQuery();
        } else {
            await this.redirectService.redirectToDefaultPage();
        }
    }
}
